// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"Video_videoWrapper__Wl4Uf","fullWidth":"Video_fullWidth__yhcJG","videoContainer":"Video_videoContainer__T3zZ6","singleVideo":"Video_singleVideo___bZR_"};